import * as _ from 'lodash';

import {
    BaseDashboardWidgetView, BaseDashboardWidgetViewOptions
} from '../../../dashboard/widgets/_BaseWidgetView';

export class DateTimeWidgetView extends BaseDashboardWidgetView {

    protected template = _.template(require('templates/reports/widgets/datetimewidget/datetimewidget.html'));

    constructor(options: BaseDashboardWidgetViewOptions) {
        super(<any> _.merge({
            tagName: "div",
            className: 'widget widget-w-6',
            events: {
                // Widget related buttons
                'click .w-settings .remove': 'handleRemoveWidgetClick',
                'click .w-delete-widget .w-cancel': 'handleRemoveWidgetCancelClick',
                'click .w-delete-widget .w-confirm': 'handleRemoveWidgetConfirmClick',
                'click .w-settings .gear': 'handleEditWidgetClick',
                'click .w-settings .clone': 'handleCloneWidget'
            }
        }, options));
    }

    render() {
        this.$el.html(this.template({
            reportId: this.options.report.get('id'),
            permissionCollection: this.options.permissionCollection,
            widget: this.options.widget,
            editable: false, // Date Time widgets can't be edited; there's nothing to edit
            movable: this.options.movable,
            cloneable: this.options.cloneable,
            deletable: this.options.deletable
        }));

        this.$el.attr('data-widget-id', this.options.widget.get('id'));
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/reports/widgets/datetimewidget/DateTimeWidgetView.ts